// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/common/jquery-3.6.0.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("/common/jquery.query.js", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("/common/jquery.json.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_3___ = new URL("/common/default.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_4___ = new URL("../../common.js", import.meta.url);
var ___HTML_LOADER_IMPORT_5___ = new URL("../index.js", import.meta.url);
var ___HTML_LOADER_IMPORT_6___ = new URL("../index.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_7___ = new URL("../../index.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_8___ = new URL("/common/timer.js", import.meta.url);
var ___HTML_LOADER_IMPORT_9___ = new URL("/common/header.js", import.meta.url);
var ___HTML_LOADER_IMPORT_10___ = new URL("/component/two-word/const.js", import.meta.url);
var ___HTML_LOADER_IMPORT_11___ = new URL("/component/two-word/two-word.js", import.meta.url);
var ___HTML_LOADER_IMPORT_12___ = new URL("/common/header.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_13___ = new URL("/component/two-word/submenu.js", import.meta.url);
var ___HTML_LOADER_IMPORT_14___ = new URL("/component/two-word/two-word.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_15___ = new URL("/common/menu_li.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_16___ = new URL("/component/two-word/guidemenu.js", import.meta.url);
var ___HTML_LOADER_IMPORT_17___ = new URL("/component/two-word/two-word_results.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_18___ = new URL("/common/sitepolicy.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_19___ = new URL("/component/infoarea.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_20___ = new URL("/fortune/common/marquee.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_21___ = new URL("/fortune/common/rank.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_22___ = new URL("/fortune/common/rank.js", import.meta.url);
var ___HTML_LOADER_IMPORT_23___ = new URL("/fortune/common/open-ranking-list.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_24___ = new URL("/fortune/common/button.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_25___ = new URL("/fortune/common/breadcrumbs.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_26___ = new URL("/common/footer.scss", import.meta.url);
// Module
var code = `<!DOCTYPE html>
<html lang="ja">
  <head
    prefix="og: http://ogp.me/ns# fb: http://ogp.me/ns/ fb# article: http://ogp.me/ns/article#"
  >
    <!-- prettier-ignore -->
    
    <!---->
    <!--デフォルト値の設定-->




<meta charset="UTF-8" />
<meta
  name="viewport"
  content="width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1"
/>
<meta name="format-detection" content="telephone=no" />
<title>星座占い ふたご座｜星座＆タロット占い｜【Ponta】お金のミカタ</title>
<meta name="description" content="ふたご座の今日の金運をチェック！あなたのミカタになるアイテムや、Pontaからのアドバイスもお見逃しなく！" />
<link rel="index" href="index.htm" />
<!-- icon -->
<link
  rel="shortcut icon"
  type="image/vnd.microsoft.icon"
  href="/cmn/img/favicon.ico"
/>
<link rel="icon" type="image/x-icon" href="/cmn/img/favicon.ico" />
<link
  rel="apple-touch-icon"
  sizes="180x180"
  href="/cmn/img/apple-touch-icon.png"
/>
<!-- og -->
<meta property="og:url" content="https://www.finance.ponta.jp/fortune/horoscope/gemini/" />
<meta property="og:type" content="website" />
<meta property="og:title" content="星座占い ふたご座｜星座＆タロット占い｜【Ponta】お金のミカタ" />
<meta property="og:description" content="ふたご座の今日の金運をチェック！あなたのミカタになるアイテムや、Pontaからのアドバイスもお見逃しなく！" />
<meta property="og:site_name" content="【Ponta】お金のミカタ" />
<meta property="og:image" content="https://www.finance.ponta.jp/fortune/images/ogp.jpg" />
<!-- Twitter -->
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:site" content="@Ponta" />

${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_0___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_1___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_2___}">${"<" + "/script"}>

<!-- StyleSheet -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_3___}" />

<!-- noto sans jp の読み込み -->
<link rel="preconnect" href="https://fonts.gstatic.com" />
<link
  rel="preload"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  as="style"
/>
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  media="print"
  onload="this.media = 'all'"
/>

<!-- corporate-logo の読み込み -->
<link rel="preload" href="/font/corporate-logo.css" as="style" />
<link
  rel="stylesheet"
  href="/font/corporate-logo.css"
  media="print"
  onload="this.media = 'all'"
/>

<!-- Google Tag Manager (loadイベント後に遅延読み込み) -->
<!-- 旧コード: Clarityとアニメーションの競合解消後に戻す
${"<" + "script"}>
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-P3QVP6P");
${"<" + "/script"}>
-->
${"<" + "script"}>
  window.dataLayer = window.dataLayer || [];
  window.addEventListener("load", function () {
    dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = document.getElementsByTagName("script")[0],
      j = document.createElement("script");
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=GTM-P3QVP6P";
    f.parentNode.insertBefore(j, f);
  });
${"<" + "/script"}>

<!-- Google広告 -->
${"<" + "script"}
  async
  src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2528660706528280"
  crossorigin="anonymous"
>${"<" + "/script"}>

    ${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_4___}">${"<" + "/script"}>
    ${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_5___}">${"<" + "/script"}>
    <link
      rel="canonical"
      href="https://www.finance.ponta.jp/fortune/horoscope/gemini/"
    />
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_6___}" />
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_7___}" />
  </head>

  <body>
    <!-- Google Tag Manager (noscript) -->
<noscript
  ><iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-P3QVP6P"
    height="0"
    width="0"
    style="display: none; visibility: hidden"
  ></iframe
></noscript>
<!-- End Google Tag Manager (noscript) -->
 <link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"
/>
${"<" + "script"} src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js">${"<" + "/script"}>
<!--タイマー読み込み-->
${"<" + "script"} src="${___HTML_LOADER_IMPORT_8___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_9___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_10___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_11___}">${"<" + "/script"}>
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_12___}" />

<header>
  <nav id="header-inner">
    <a id="ponta-logo" data-id="header-mikata_Ponta-logo" href="/">
      <img
        src="/cmn/img/logo_okaneponta.svg"
        alt="Ponta"
        width="59"
        height="13"
      />
    </a>
    <ul class="global-menu">
      <li class="tab-list-item mikata active_tab">
        <h1 id="site-title">
          <a href="/" data-id="header-mikata_tabmenu_mikata">お金のミカタ</a>
        </h1>
      </li>
      <li class="tab-list-item column">
        <a
          href="https://column.finance.ponta.jp/"
          data-id="header-mikata_tabmenu_column"
          >ミカタイムズ</a
        >
      </li>
    </ul>
  </nav>
  <nav id="sub_menu">
    <div class="sub-list-wrapper">
      <ul class="sub-list">
        <li class="sub-list-item">
          <a href="/mottainai/" data-id="hamburger_mottainai">もったいない</a>
        </li>
        <li class="sub-list-item">
          <a href="/money-ponkatsu/" data-id="hamburger_money-ponkatsu"
            >マネPon</a
          >
        </li>
        <li class="sub-list-item">
          <a href="/fortune/" data-id="hamburger_fortune">金運</a>
        </li>
        <li class="sub-list-item">
          <a href="/money/" data-id="hamburger_ponta-finance">銀行証券</a>
        </li>
        <li class="sub-list-item">
          <a href="/insurance/" data-id="hamburger_hoken">保険</a>
        </li>
      </ul>
    </div>
    <div class="sub-menu-two-words">
      
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_13___}">${"<" + "/script"}>
  

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_14___}" />

<div id="sub-menu_two-words">
  <div id="sub-menu_first_word__dropdown" class="dropdown">
    <div
      id="sub-menu_first_word__toggle"
      class="first_word__toggle dropdown__toggle"
    >
      <span>➀ やりたいこと</span>
    </div>
    <div id="sub-menu_first_word__menu-base" class="menu-base">
      <ul
        id="sub-menu_first_word__menu"
        class="dropdown__menu first_word__menu"
        data-id="header-mikata_navimenu_search1"
      >
        <li class="option disabled">① やりたいことを選択 ▼</li>
      </ul>
    </div>
  </div>
  <div id="sub-menu_second_word__dropdown" class="dropdown">
    <div id="sub-menu_second_word__toggle" class="dropdown__toggle">
      <span>➁ どうやって？</span>
    </div>
    <div id="sub-menu_second_word__menu-base" class="menu-base">
      <ul
        id="sub-menu_second_word__menu"
        class="dropdown__menu second_word__menu"
        data-id="header-mikata_navimenu_search2"
      >
        <li class="option disabled">➁ どうやって？ ▼</li>
      </ul>
    </div>
  </div>
</div>

    </div>
    <div class="guide-menu-container">
      <input
        id="drawer_input"
        class="drawer_hidden"
        type="checkbox"
        data-id="header-mikata_openmenu"
      />
      <label for="drawer_input" class="guide-menu-open">
        <img src="/cmn/img/hamburger.svg" width="28.5" height="18" />
        <span>MENU</span>
      </label>
      <div id="guide-menu">
        <div class="guide-menu-wrapper">
          <div class="guide-menu-header">
            <div class="guide-menu-title">
              <a href="/">
                <img
                  src="/cmn/img/logo_menu-mikata.svg"
                  alt="Ponta お金のミカタ"
                  　width="260"
                  height="27"
                />
              </a>
            </div>
            <label for="drawer_input" class="guide-menu-close">
              <img src="/cmn/img/close.svg" />
              <span>CLOSE</span>
            </label>
          </div>
          <ul class="category_list">
            <!-- prettier-ignore -->
            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/mottainai/"
    data-id="hamburger_mottainai"
    target=""
    rel=""
  >
    知らないなんてもったいない！
  </a>
  
  <input
    id="drawer-ponta_10"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_10" class="drawer_open">
    <span id="drawer_span_10">＋</span>
  </label>
  <ul id="menu2_10" class="menu2">
    
    <li>
      <a
        href="/mottainai/type/"
        data-id="hamburger_mottainai_type"
        target=""
        rel=""
        >もったいない診断</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/mufg/"
        data-id="hamburger_mottainai_mufg"
        target=""
        rel=""
        >三菱UFJ銀行</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/lawsonbank/atm/"
        data-id="hamburger_mottainai_lawsonbank_atm"
        target=""
        rel=""
        >ぽんたまATM</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/lawsonbank/credit/"
        data-id="hamburger_mottainai_lawsonbank_credit"
        target=""
        rel=""
        >ローソンPontaプラス</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/connect-sec/"
        data-id="hamburger_mottainai_connect-sec"
        target=""
        rel=""
        >大和コネクト証券</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/insurance/fp/"
        data-id="hamburger_mottainai_insurance_fp"
        target=""
        rel=""
        >ライフプラン表作成サービス</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/game/"
        data-id="hamburger_mottainai_game"
        target=""
        rel=""
        >金融ゲーム</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/rental-subsc/"
        data-id="hamburger_mottainai_rental-subsc"
        target=""
        rel=""
        >家電レンタルサービス（アリスプライム）</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/money-ponkatsu/?from=hamburger_money-ponkatsu"
    data-id="hamburger_money-ponkatsu"
    target=""
    rel=""
  >
    マネPon（楽しみながらためる）
  </a>
  
  <input
    id="drawer-ponta_1"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_1" class="drawer_open">
    <span id="drawer_span_1">＋</span>
  </label>
  <ul id="menu2_1" class="menu2">
    
    <li>
      <a
        href="/2-choices/"
        data-id="hamburger_2-choices"
        target=""
        rel=""
        >2択でPonta</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/money/"
    data-id="hamburger_ponta-finance"
    target=""
    rel=""
  >
    Pontaファイナンス
  </a>
  
  <input
    id="drawer-ponta_2"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_2" class="drawer_open">
    <span id="drawer_span_2">＋</span>
  </label>
  <ul id="menu2_2" class="menu2">
    
    <li>
      <a
        href="/money/#saving_point"
        data-id="hamburger_ponta-finance_saving_point"
        target=""
        rel=""
        >金融機関でポイントをためる</a
      >
    </li>
    
    <li>
      <a
        href="/money/#invest-trial_point"
        data-id="hamburger_ponta-finance_invest-trial_point"
        target=""
        rel=""
        >投資体験でポイントを増やす</a
      >
    </li>
    
    <li>
      <a
        href="/money/#invest_point"
        data-id="hamburger_ponta-finance_invest_point"
        target=""
        rel=""
        >ポイントをつかってリアル投資</a
      >
    </li>
    
  </ul>
  
</li>

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/insurance/"
    data-id="hamburger_hoken"
    target=""
    rel=""
  >
    Pontaの保険
  </a>
  
  <input
    id="drawer-ponta_3"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_3" class="drawer_open">
    <span id="drawer_span_3">＋</span>
  </label>
  <ul id="menu2_3" class="menu2">
    
    <li>
      <a
        href="/insurance/#insurance-easy"
        data-id="hamburger_hoken_kantan"
        target=""
        rel=""
        >1日から入れる保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-hokepon"
        data-id="hamburger_hoken_hokepon"
        target=""
        rel=""
        >Ponta会員限定保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-au-seimei"
        data-id="hamburger_hoken_au-seimei"
        target=""
        rel=""
        >ポイントがたまる生命保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-living"
        data-id="hamburger_hoken_living"
        target=""
        rel=""
        >暮らしの保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-pet"
        data-id="hamburger_hoken_pet"
        target=""
        rel=""
        >わんにゃん保険</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/lifeplan/"
    data-id="hamburger_lifeplan"
    target=""
    rel=""
  >
    ライフプラン表作成サービス
  </a>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/diagnosis/"
    data-id="hamburger_400f"
    target=""
    rel=""
  >
    お金の相談窓口（オカネコ）
  </a>
  
</li>

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/fortune/"
    data-id="hamburger_fortune"
    target=""
    rel=""
  >
    星座＆タロット占い
  </a>
  
  <input
    id="drawer-ponta_6"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_6" class="drawer_open">
    <span id="drawer_span_6">＋</span>
  </label>
  <ul id="menu2_6" class="menu2">
    
    <li>
      <a
        href="/fortune/#horoscope-rank"
        data-id="hamburger_fortune_horoscope"
        target=""
        rel=""
        >今日の金運ランキング</a
      >
    </li>
    
    <li>
      <a
        href="/fortune/tarot/"
        data-id="hamburger_fortune_tarot"
        target=""
        rel=""
        >タロット占い</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/campaign/"
    data-id="hamburger_campaign-list"
    target=""
    rel=""
  >
    キャンペーン一覧
  </a>
  
</li>

          </ul>
          <div class="guide-menu_two-words_container">
            <p>二言で検索</p>
             
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_16___}">${"<" + "/script"}>
 

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_14___}" />

<div id="guide-menu_two-words">
  <div id="guide-menu_first_word__dropdown" class="dropdown">
    <div
      id="guide-menu_first_word__toggle"
      class="first_word__toggle dropdown__toggle"
    >
      <span>➀ やりたいこと</span>
    </div>
    <div id="guide-menu_first_word__menu-base" class="menu-base">
      <ul
        id="guide-menu_first_word__menu"
        class="dropdown__menu first_word__menu"
        data-id="header-mikata_navimenu_search1"
      >
        <li class="option disabled">① やりたいことを選択 ▼</li>
      </ul>
    </div>
  </div>
  <div id="guide-menu_second_word__dropdown" class="dropdown">
    <div id="guide-menu_second_word__toggle" class="dropdown__toggle">
      <span>➁ どうやって？</span>
    </div>
    <div id="guide-menu_second_word__menu-base" class="menu-base">
      <ul
        id="guide-menu_second_word__menu"
        class="dropdown__menu second_word__menu"
        data-id="header-mikata_navimenu_search2"
      >
        <li class="option disabled">➁ どうやって？ ▼</li>
      </ul>
    </div>
  </div>
</div>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_17___}" />
<div
  id="guide-menu_search_results"
  class="search_results_guide-menu search_results"
>
  <div class="swiper guide-menu_search_results_swiper">
    <ul id="guide-menu_search_results_ul" class="swiper-wrapper">
      <li id="search_result_container" class="swiper-slide">
        <div class="search_result_container">
          <a class="link" href="/">
            <img class="ogp_image" src="/cmn/img/ogp_image_sample.svg" />
            <p class="title">タイトル</p>
          </a>
        </div>
      </li>
    </ul>
    <div class="guide-menu_swiper-scrollbar swiper-scrollbar"></div>
  </div>
  <div
    id="non-exist_search_results_guide-menu"
    class="non-exist_search_results"
  >
    <p>検索結果がありません。</p>
  </div>
  <div class="close_search_results_container">
    <a class="close_search_results" onclick="closeResults('guide-menu')">
      検索結果を閉じる ✕
    </a>
  </div>
</div>

          </div>
          <div class="guide-menu_sitepolicy_container">
            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_18___}" />
<ul class="sitepolicy-link">
  <li>
    <a href="/about/#insurance_inquiry" data-id="guide-menu_inquiry"
      >お問い合わせ一覧</a
    >
  </li>
  <li>
    <a
      href="/about/solicitation_policy/"
      data-id="guide-menu_solicitation-policy"
      >代理店勧誘方針について</a
    >
  </li>
  <li>
    <a href="/about/" data-id="guide-menu_site-guide"
      >お金のミカタについて</a
    >
  </li>
  <li>
    <a href="/about/sitemap/" data-id="guide-menu_sitemap"
      >サイトマップ</a
    >
  </li>
</ul>

          </div>
        </div>
      </div>
    </div>
  </nav>
  <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_17___}" />
<div
  id="sub-menu_search_results"
  class="search_results_sub-menu search_results"
>
  <div class="swiper sub-menu_search_results_swiper">
    <ul id="sub-menu_search_results_ul" class="swiper-wrapper">
      <li id="search_result_container" class="swiper-slide">
        <div class="search_result_container">
          <a class="link" href="/">
            <img class="ogp_image" src="/cmn/img/ogp_image_sample.svg" />
            <p class="title">タイトル</p>
          </a>
        </div>
      </li>
    </ul>
    <div class="sub-menu_swiper-scrollbar swiper-scrollbar"></div>
  </div>
  <div
    id="non-exist_search_results_sub-menu"
    class="non-exist_search_results"
  >
    <p>検索結果がありません。</p>
  </div>
  <div class="close_search_results_container">
    <a class="close_search_results" onclick="closeResults('sub-menu')">
      検索結果を閉じる ✕
    </a>
  </div>
</div>

</header>
<!-- お知らせエリア（通常は非表示） -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_19___}" />

<dl id="info-top" class="red">
  <dt><span>重要なお知らせ</span></dt>
  <dd>
    <!--<b>10月22日</b>-->　
    現在、お金のミカタ内の一部サービスにおいて、セキュリティ対応等のためメンテナンスを実施しております。メンテナンス期間中は、対象となる一部サービスをご利用いただけない場合がございます。ご利用のお客様にはご不便をおかけし、申し訳ございません。ご理解いただきますよう、お願い申し上げます。
  </dd>
</dl>

<!--
<dl id="info-top">
    <dt><span>お知らせ</span></dt>
    <dd>
        <a href="https://www.finance.ponta.jp/campaign/risoku20220329/?from=info_risoku">＼Pontaポイント利息で増えるキャンペーン実施中／</a>
    </dd>
</dl>
-->


    <div class="body-contents">
      <main>
        <!--Google広告ここから-->
        <div class="google-ads">
          ${"<" + "script"}
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2528660706528280"
            crossorigin="anonymous"
          >${"<" + "/script"}>
          <!-- 占い_タロットヘッダ_固定_320×100 -->
          <ins
            class="adsbygoogle"
            style="display: inline-block; width: 320px; height: 100px"
            data-ad-client="ca-pub-2528660706528280"
            data-ad-slot="8867038243"
          ></ins>
          ${"<" + "script"}>
            (adsbygoogle = window.adsbygoogle || []).push({});
          ${"<" + "/script"}>
        </div>
        <!--Google広告ここまで-->
        <div class="horoscope is-gemini">
          <div class="horoscope-head">
  <div data-js="horoscope-content" style="opacity: 0">
    <span class="is-date" data-js="horoscope-month"></span>
    <span class="is-01"
      ><img
        src="/fortune/images/horoscope-date_01.png"
        width="17"
        height="26"
        alt="月"
    /></span>
    <span class="is-date" data-js="horoscope-day"></span>
    <span class="is-02"
      ><img
        src="/fortune/images/horoscope-date_02.png"
        width="231"
        height="34"
        alt="日の金運をみる"
    /></span>
  </div>
</div>
<h1 class="horoscope-ttl">
  <img class="u-pc" src="/fortune/images/ttl-horoscope.png" alt="星座占い" />
  <img class="u-sp" src="/fortune/images/ttl-horoscope-sp.png" alt="星座占い" />
</h1>


          <div class="horoscope-zodiac">
            <div class="horoscope-zodiac-head">
              <img
                class="u-pc"
                src="/fortune/images/horoscope_03_pc.png"
                width="898"
                height="108"
                alt="ふたご座"
              />
              <img
                class="u-sp"
                src="/fortune/images/horoscope_03_sp.png"
                width="898"
                height="108"
                alt="ふたご座"
              />
            </div>

            <div class="horoscope-content">
  <div class="horoscope-article">
    <div class="horoscope-article-ttl">money luck</div>
    <div class="horoscope-article-rank is-economic">
      <div
        class="horoscope-article-economic"
        data-js="horoscope-content"
        style="opacity: 0"
      >
        <div class="horoscope-article-economic-img">
          <img
            class="u-pc"
            width="212"
            height="89"
            data-js="horoscope-ranking-pc"
            alt=""
          />
          <img
            class="u-sp"
            width="608"
            height="118"
            data-js="horoscope-ranking-sp"
            alt=""
          />
        </div>
      </div>
      <div class="horoscope-article-rank-main">
        <p class="horoscope-article-rank-ttl is-money">
          <img
            src="/fortune/images/horoscope-text-money.png"
            width="96"
            height="46"
            alt="金運"
          />
        </p>
        <div
          class="horoscope-article-rank-rate"
          data-js="horoscope-content"
          style="opacity: 0"
        >
          <img data-js="horoscope-money-star" width="291" height="51" alt="" />
        </div>
      </div>
    </div>
    <div
      class="horoscope-article-detail"
      data-js="horoscope-content"
      style="opacity: 0"
    >
      <p data-js="horoscope-money-text"></p>
    </div>
  </div>
  <div class="horoscope-article">
    <div class="horoscope-article-ttl">career luck</div>
    <div class="horoscope-article-rank is-career">
      <div class="horoscope-article-rank-main">
        <p class="horoscope-article-rank-ttl is-career">
          <img
            src="/fortune/images/horoscope-text-career.png"
            width="156"
            height="49"
            alt="仕事運"
          />
        </p>
        <div
          class="horoscope-article-rank-rate"
          data-js="horoscope-content"
          style="opacity: 0"
        >
          <img data-js="horoscope-career-star" width="291" height="51" alt="" />
        </div>
      </div>
    </div>
    <div
      class="horoscope-article-detail"
      data-js="horoscope-content"
      style="opacity: 0"
    >
      <p data-js="horoscope-career-text"></p>
    </div>
  </div>
  <div class="horoscope-article">
    <div class="horoscope-article-ttl">love luck</div>
    <div class="horoscope-article-rank is-love">
      <div class="horoscope-article-rank-main">
        <p class="horoscope-article-rank-ttl is-love">
          <img
            src="/fortune/images/horoscope-text-love.png"
            width="95"
            height="48"
            alt="恋愛運"
          />
        </p>
        <div
          class="horoscope-article-rank-rate"
          data-js="horoscope-content"
          style="opacity: 0"
        >
          <img data-js="horoscope-love-star" width="291" height="51" alt="" />
        </div>
      </div>
    </div>
    <div
      class="horoscope-article-detail"
      data-js="horoscope-content"
      style="opacity: 0"
    >
      <p data-js="horoscope-love-text"></p>
    </div>
  </div>
  <div class="horoscope-article">
    <div class="horoscope-article-ttl">health luck</div>
    <div class="horoscope-article-rank is-health">
      <div class="horoscope-article-rank-main">
        <p class="horoscope-article-rank-ttl is-health">
          <img
            src="/fortune/images/horoscope-text-health.png"
            width="155"
            height="50"
            alt="健康運"
          />
        </p>
        <div
          class="horoscope-article-rank-rate"
          data-js="horoscope-content"
          style="opacity: 0"
        >
          <img data-js="horoscope-health-star" width="291" height="51" alt="" />
        </div>
      </div>
    </div>
    <div
      class="horoscope-article-detail"
      data-js="horoscope-content"
      style="opacity: 0"
    >
      <p data-js="horoscope-health-text"></p>
    </div>
  </div>
</div>

          </div>
          <div class="horoscope-advice">
  <h4 class="horoscope-advice-ttl">
    <img
      src="/fortune/images/horoscope-advice-title.png"
      width="654"
      height="45"
      alt="あなたのミカタ！アドバイス"
    />
  </h4>
  <div class="horoscope-advice-main">
    <div class="horoscope-advice-content">
      <div class="horoscope-advice-ponta">
        <img src="/fortune/images/fortune-mv-ponta.png" alt="Ponta" />
      </div>
      <div
        class="horoscope-advice-txt"
        data-js="horoscope-content"
        style="opacity: 0"
      >
        <p data-js="horoscope-summary"></p>
      </div>
    </div>
    <div class="horoscope-advice-articles">
      <div class="horoscope-advice-article">
        <p class="horoscope-advice-article-lb is-color">
          <img
            src="/fortune/images/horoscope-advice-article-lb-color.png"
            width="194"
            height="23"
            alt="ラッキーカラー"
          />
        </p>
        <p
          class="horoscope-advice-article-txt"
          data-js="horoscope-content"
          style="opacity: 0"
        >
          <span data-js="horoscope-color"></span
          ><span class="dot" data-js="horoscope-color-dot"></span>
        </p>
      </div>
      <div class="horoscope-advice-article">
        <p class="horoscope-advice-article-lb is-item">
          <img
            src="/fortune/images/horoscope-advice-article-lb-item.png"
            width="222"
            height="24"
            alt="ラッキーアイテム"
          />
        </p>
        <p
          class="horoscope-advice-article-txt"
          data-js="horoscope-content"
          style="opacity: 0"
        >
          <span data-js="horoscope-item"></span>
        </p>
      </div>
    </div>
    <div class="horoscope-advice-socical">
      <div class="horoscope-advice-socical-link">
        <a
          data-id="horoscope_sns_line"
          href="https://social-plugins.line.me/lineit/share?from=horoscope_sns_line&url=https://www.finance.ponta.jp/fortune/horoscope/"
          target="_blank"
          class="u-hover"
          data-js="horoscope-share-link"
        >
          <img src="/fortune/images/ic-line.png" alt="Line" />
        </a>
        <a
          data-id="horoscope_sns_facebook"
          href="https://www.facebook.com/share.php?u=https://www.finance.ponta.jp/fortune/horoscope/"
          target="_blank"
          class="u-hover"
          data-js="horoscope-share-link"
        >
          <img src="/fortune/images/ic-fb.png" alt="Facebook" />
        </a>
        <a
          data-id="horoscope_sns_x"
          href="https://twitter.com/intent/tweet?from=horoscope_sns_x&url=https://www.finance.ponta.jp/fortune/horoscope/"
          target="_blank"
          class="u-hover"
          data-js="horoscope-share-link"
        >
          <img src="/fortune/images/ic-x.png" alt="X" />
        </a>
      </div>
      <div class="horoscope-advice-socical-txt">
        占いは毎日AM0:00に更新します。
      </div>
    </div>
  </div>
</div>
 <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_20___}" />
<div class="mv-marquee">
  <figure class="mv-marquee-inner">
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
  </figure>
</div>

          <!-- <link rel="stylesheet" href="/fortune/common/recommend.scss" />

<div class="recommend">
  <div class="recommend-ttl">
    <h4><img src="/fortune/images/recommend-title.png" width="648" height="46" alt="あなたへのおすすめ" /></h4>
  </div>
  <div class="recommend-articles">
    
      <a class="recommend-article u-hover" data-id="horoscope_banner1" href="https://www.finance.ponta.jp/diagnosis/?utm_source=mikata&amp;utm_medium=banner&amp;utm_campaign=mikata_tarot-carousel_onayamiall_banner230920&from=horoscope_banner1" target="">
        <img src="/fortune/images/recommend/04_800x300_b_02.jpg" alt="オカネコチャットバナー（モヤモヤponta）" />
      </a>
    
      <a class="recommend-article u-hover" data-id="horoscope_banner2" href="https://www.finance.ponta.jp/money/mufg/?utm_source=mikata&amp;utm_medium=banner&amp;utm_campaign=mikata_ponkatsu-carousel_mufg230920&from=horoscope_banner2" target="">
        <img src="/fortune/images/recommend/banner2_mufg_800‐300.png" alt="MUFG（えーそうなの？）" />
      </a>
    
  </div>
</div>
  -->
          <!--星座ランキングコンポーネント　呼び出し例-->
<!-- include("fortune/common/_rank.ejs", {mode:"middle"}) -->
<!--modeの値：full→全順位表示、middle→中間のみ表示、top→上位3位表示-->

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_21___}" />
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_22___}">${"<" + "/script"}>

<div id="horoscope-rank" class="fortune-rank">
  <div class="fortune-rank-ttl">
    <div>
      <h4>
        <img
          src="/fortune/images/fortune-ttl-ranking.png"
          alt="今日の金運ランキング"
        />
      </h4>
      <figure class="fortune-rank-ttl-lb">
        <img
          src="/fortune/images/fortune-ranking.png"
          width="146"
          height="97"
          alt="Ranking"
        />
      </figure>
    </div>
  </div>
  <div
    class="fortune-rank-list is-closed is-top not-middle"
    data-js="rank-container"
    style="opacity: 0"
  >
    <div class="fortune-rank-item" data-js="rank-item">
      <a class="fortune-rank-item-img u-hover" href="/fortune/horoscope/aries/">
        <img
          src="/fortune/images/icon-aries.png"
          width="173"
          height="173"
          alt="Aries"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">おひつじ座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a
        class="fortune-rank-item-img u-hover"
        href="/fortune/horoscope/taurus/"
      >
        <img
          src="/fortune/images/icon-taurus.png"
          width="173"
          height="173"
          alt="Taurus"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">おうし座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a
        class="fortune-rank-item-img u-hover"
        href="/fortune/horoscope/gemini/"
      >
        <img
          src="/fortune/images/icon-gemini.png"
          width="173"
          height="173"
          alt="Gemini"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">ふたご座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a
        class="fortune-rank-item-img u-hover"
        href="/fortune/horoscope/cancer/"
      >
        <img
          src="/fortune/images/icon-cancer.png"
          width="173"
          height="173"
          alt="Cancer"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">かに座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a class="fortune-rank-item-img u-hover" href="/fortune/horoscope/leo/">
        <img
          src="/fortune/images/icon-leo.png"
          width="173"
          height="173"
          alt="Leo"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">しし座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a class="fortune-rank-item-img u-hover" href="/fortune/horoscope/virgo/">
        <img
          src="/fortune/images/icon-virgo.png"
          width="173"
          height="173"
          alt="Virgo"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">おとめ座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a class="fortune-rank-item-img u-hover" href="/fortune/horoscope/libra/">
        <img
          src="/fortune/images/icon-libra.png"
          width="173"
          height="173"
          alt="Libra"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">てんびん座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a
        class="fortune-rank-item-img u-hover"
        href="/fortune/horoscope/scorpio/"
      >
        <img
          src="/fortune/images/icon-scorpio.png"
          width="173"
          height="173"
          alt="Scorpio"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">さそり座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a
        class="fortune-rank-item-img u-hover"
        href="/fortune/horoscope/sagittarius/"
      >
        <img
          src="/fortune/images/icon-sagittarius.png"
          width="173"
          height="173"
          alt="Sagittarius"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">いて座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a
        class="fortune-rank-item-img u-hover"
        href="/fortune/horoscope/capricorn/"
      >
        <img
          src="/fortune/images/icon-capricorn.png"
          width="173"
          height="173"
          alt="Capricorn"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">やぎ座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a
        class="fortune-rank-item-img u-hover"
        href="/fortune/horoscope/aquarius/"
      >
        <img
          src="/fortune/images/icon-aquarius.png"
          width="173"
          height="173"
          alt="Aquarius"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">みずがめ座</p>
      </div>
    </div>
    <div class="fortune-rank-item" data-js="rank-item">
      <a
        class="fortune-rank-item-img u-hover"
        href="/fortune/horoscope/pisces/"
      >
        <img
          src="/fortune/images/icon-pisces.png"
          width="173"
          height="173"
          alt="Pisces"
        />
      </a>
      <div class="fortune-rank-item-inner">
        <p class="fortune-rank-item-number">
          <span data-js="rank-no"></span>位
        </p>
        <p class="fortune-rank-item-name">うお座</p>
      </div>
    </div>

     <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_23___}" />

<button type="button" data-js="open-ranking-list" class="open-ranking-list">
  <div>
    <p>ランキング全体を見る</p>
    <figure>
      <img src="/fortune/images/plus.png" alt="" />
    </figure>
  </div>
</button>
 
  </div>
</div>

          <div class="tarot-reading">
            <h3 class="tarot-reading-ttl">
  <img
    class="u-pc"
    src="/fortune/images/fortune-ttl-tarot.png"
    alt="[タロット占い] Tarot reading"
  />
  <img
    class="u-sp"
    src="/fortune/images/fortune-ttl-tarot-sp.png"
    alt="[タロット占い] Tarot reading"
  />
</h3>
<p class="tarot-reading-txt"> 知りたいカテゴリやテーマを選んで、カードを1枚めくってみましょう。<br />そこに未来へのヒントが隠れているはずです。 </p>
<div class="tarot-reading-recommend">
  <div>
    <h4>
      <img
        src="/fortune/images/tarot-ttl-recommend.png"
        alt="ピックアップテーマ"
      />
    </h4>
    <img
      class="tarot-reading-recommend-pickup"
      src="/fortune/images/pickup.png"
      width="66"
      height="61"
      alt="Pickup"
    />
  </div>
</div>
<div class="tarot-link bg-gray">
  <a
    data-id="horoscope_tarot_pickup1"
    href="/fortune/tarot/theme1/?from=horoscope_tarot_pickup1"
    class="tarot-link-item u-hover"
    >お金がたまらない原因は？</a
  >
  <a
    data-id="horoscope_tarot_pickup2"
    href="/fortune/tarot/theme12/?from=horoscope_tarot_pickup2"
    class="tarot-link-item u-hover"
    >運命の人とはもう出会っている？</a
  >
</div>

            <div class="horoscope-btn">
              <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_24___}" />
<!---->
<!-- prettier-ignore -->
<div class="btn black ">
  <a class="u-hover" data-id="horoscope_tarot_enter" href="/fortune/tarot/?from=horoscope_tarot_enter">
    <span>
      
    </span>
    タロット占いをはじめる
    <span>
      
      <img src="/fortune/images/arrow-link-white.png" width="26" height="9" alt="" />
       
    </span>
  </a>
</div>

            </div>
          </div>
          <div class="horoscope-btn">
            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_24___}" />
<!---->
<!-- prettier-ignore -->
<div class="btn white ">
  <a class="u-hover" data-id="horoscope_back_top" href="/fortune/?from=horoscope_back_top">
    <span>
      
      <img src="/fortune/images/arrow-link-black.png" width="26" height="9" alt="" />
      
    </span>
    占いTOPへ戻る
    <span>
       
    </span>
  </a>
</div>

          </div>
        </div>
        
<!---->

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_25___}" />

<nav class="breadcrumbs">
  <ul>
    
      <li><a href="/">ホーム</a></li>
    
      <li><a href="/fortune/">星座＆タロット占い</a></li>
    
    <li>星座占い ふたご座</li>
  </ul>
</nav>

      </main>
      <!-- /.inner -->
    </div>
    <!-- /#contents -->

    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_26___}" />
<div id="footer-address">
  <!-- 戻るリンク -->
  <div id="pagetop">
    <a href="#"
      ><img
        src="/cmn/img/top_ponta.svg"
        alt="TOPへ戻る"
        width="69"
        height="89"
        loading="lazy"
    /></a>
  </div>
  <div class="footer-address-wrapper">
    <address id="address_top">
      保険取扱代理店：株式会社 ロイヤリティマーケティング<br />
      〒150-0013　東京都渋谷区恵比寿1-18-14 恵比寿ファーストスクエア 7階
    </address>
    <p>
      このホームページは、各保険商品の概要についてご紹介しております。<br />
      補償内容の確認やご契約及びご加入にあたっては、各保険商品のリンク内をご確認ください。
    </p>
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_18___}" />
<ul class="sitepolicy-link">
  <li>
    <a href="/about/#insurance_inquiry" data-id="footer_inquiry"
      >お問い合わせ一覧</a
    >
  </li>
  <li>
    <a
      href="/about/solicitation_policy/"
      data-id="footer_solicitation-policy"
      >代理店勧誘方針について</a
    >
  </li>
  <li>
    <a href="/about/" data-id="footer_site-guide"
      >お金のミカタについて</a
    >
  </li>
  <li>
    <a href="/about/sitemap/" data-id="footer_sitemap"
      >サイトマップ</a
    >
  </li>
</ul>

  </div>
</div>
<footer id="FOOTER" class="footer">
  <ul>
    <li>
      <a
        href="https://policy.ponta.jp/c/privacy/index3.htm?from=footer_technology"
        data-id="footer_technology"
        target="_blank"
        rel="noopener"
        >利用技術及び外部送信ポリシー</a
      >
    </li>
    <li>
      <a
        href="https://www.ponta.jp/c/dpc/?from=footer_ponta-app"
        data-id="footer_ponta-app"
        target="_blank"
        rel="noopener"
        >Pontaアプリ</a
      >
    </li>
    <li>
      <a
        href="https://www.loyalty.co.jp/?from=footer_company"
        data-id="footer_company"
        target="_blank"
        rel="noopener"
        >運営会社</a
      >
    </li>
  </ul>
  <p class="copy">©Ponta</p>
</footer>


    <!-- /.container-wrap .rsp -->
  </body>
</html>
`;
// Exports
export default code;